import React, { Component } from 'react';
import DailyNewsService from '../../../services/daily-news';
import formattersService from '../../../services/formatters/index';

import './future-post.css';

class FuturePost extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false
    };

    this.post(props);
  }

  componentDidUpdate(props) {
    // this.post(props);
  }

  post(props) {
    let newsUrl = props.match.params[0];
    const queryParams = props.location.search;
    newsUrl += queryParams ? queryParams : '';

    DailyNewsService.addFuturePost(newsUrl)    
      .then((newsOrSuccessMessage) => {
        if (typeof newsOrSuccessMessage === 'string') return this.setState({ successMessage: newsOrSuccessMessage });
        this.setState({ ...newsOrSuccessMessage });
      })
      .catch((err) => {
        const errorMessage = err && err.response && err.response.data;
        this.setState({ isError: true, errorMessage: errorMessage });
      });
  }

  render() {
    let body = 'Processing...';
    const { postbackUrl, date, title, paragraphs } = this.state;

    if (postbackUrl) {
      body = (
        <div>
          <div><a href={postbackUrl}>{postbackUrl}</a></div>
          <div className='date'>Date: {formattersService.formatDate(date)}</div>
          <div>
            <h4>{title}</h4>
            <br />
            
            {
              paragraphs.map(p => <p>{p}<br /></p>)
            }

            <p>{postbackUrl}</p>
          </div>
        </div>
      );
    }

    const { isError, errorMessage, successMessage } = this.state;

    if (isError) {
      body = 'Error';
      body += errorMessage ? `: ${errorMessage}` : '';
    }

    if (successMessage) {
      body = successMessage;
    }

    return (
      <section className='regular-page'>
        {body}
      </section>
    );
  }
}

export default FuturePost;
